import PropTypes from "prop-types";
import clsx from "clsx";

function HistoryCard(props) {
  const typeTitle = "title";
  const labelTitle = "label";
  const labelENTitle = "labelen";
  const imageTitle = "image";
  const { animActive, year, content = [{ type: "", data: "" }] } = props;

  return (
    <div className="history-card">
      <svg
        className={clsx("line", animActive && "active")}
        width="1058"
        height="96"
        viewBox="0 0 1058 96"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M4 4L102.5 91H1057.5" stroke="#D9D9D9" strokeWidth="10" />
      </svg>
      <div className="fade-in-anim year">{year}</div>
      {content.map((element) => {
        switch (element.type) {
          case typeTitle:
            return (
              <div key={element.data} className="fade-in-anim title">
                {element.data}
              </div>
            );
          case labelTitle:
            return (
              <div key={element.data} className="fade-in-anim label">
                ♙ {element.data}
              </div>
            );
          case labelENTitle:
            return (
              <div key={element.data} className="fade-in-anim labelen">
                {element.data}
              </div>
            );
          case imageTitle:
            return (
              <div key={element.data} className="fade-in-anim image">
                <img src={element.data} alt={element.data} />
              </div>
            );
          default:
            return null;
        }
      })}
    </div>
  );
}

export default HistoryCard;

HistoryCard.propTypes = {
  animActive: PropTypes.bool,
  year: PropTypes.string,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      data: PropTypes.string,
    })
  ),
};
